export const DEFAULT_NUMBER = '0';
const intlNumberFormatterCache = new Map();
var NumberFormatterType;
(function (NumberFormatterType) {
    NumberFormatterType["Fraction"] = "Fraction";
    // only for decimal < 1
    NumberFormatterType["Significant"] = "Significant";
})(NumberFormatterType || (NumberFormatterType = {}));
const genCacheKey = (type = NumberFormatterType.Fraction, minDigits, maxDigits, locales) => [type, minDigits, maxDigits, locales?.toString()].join('_');
const getFormatter = (...args) => {
    const min = args[0] === NumberFormatterType.Fraction ? args[1] ?? 0 : undefined;
    const max = args[2] ?? min;
    const cacheKey = genCacheKey(args[0], min, max, args[3]);
    const formatter = intlNumberFormatterCache.get(cacheKey) ??
        new Intl.NumberFormat(args[3], {
            [`minimum${args[0]}Digits`]: min,
            [`maximum${args[0]}Digits`]: max,
        });
    if (!intlNumberFormatterCache.has(cacheKey)) {
        intlNumberFormatterCache.set(cacheKey, formatter);
    }
    return formatter;
};
export const formatInvalidHOC = (f, { NaNString = DEFAULT_NUMBER, zeroString } = {}) => (value, ...args) => {
    if (typeof value === 'number' && !value) {
        if (isNaN(value))
            return NaNString;
        if (typeof zeroString !== 'undefined')
            return zeroString;
    }
    return f(value, ...args);
};
export const SORTED_UNITS = [
    {
        unit: 'B',
        base: 10 ** 9,
    },
    {
        unit: 'M',
        base: 10 ** 6,
    },
    {
        unit: 'K',
        base: 10 ** 3,
    },
];
export const formatFraction = (value, ...args) => getFormatter(NumberFormatterType.Fraction, ...args).format(value);
export const formatSignificant = (value, min, ...args) => getFormatter(NumberFormatterType.Significant, undefined, ...args).format(value);
